import { render } from "./App.vue?vue&type=template&id=f6a04328&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f6a04328&lang=scss"

import exportComponent from "/Users/harshit/Documents/Work/notify/notifymobileweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__